import { render, staticRenderFns } from "./boardThumbnailPage.vue?vue&type=template&id=018e4d5d&"
import script from "./boardThumbnailPage.vue?vue&type=script&lang=js&"
export * from "./boardThumbnailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports